import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Service to manage QR/Aztec code visibility state.
 * Provides a centralized way to track when codes are actually being displayed,
 * allowing components like animations to synchronize with the actual code visibility.
 */
@Injectable({
    providedIn: 'root'
})
export class TicketQrVisibilityService {
    private readonly codeVisibilitySubject = new BehaviorSubject<boolean>(false);

    public readonly isCodeVisible$ = this.codeVisibilitySubject.asObservable();

    get isCodeVisible(): boolean {
        return this.codeVisibilitySubject.value;
    }

    setCodeVisibility(isVisible: boolean): void {
        if (this.codeVisibilitySubject.value !== isVisible) {
            this.codeVisibilitySubject.next(isVisible);
        }
    }

    reset(): void {
        this.codeVisibilitySubject.next(false);
    }
}
